'use strict';

function TraversingStack() {
    this.stack = [];
}

TraversingStack.prototype.push = function push(collection) {
    if (collection && collection.length) {
        this.stack.unshift({
            collection: collection,
            i: 0
        });
    }
};

TraversingStack.prototype.pop = function pop() {
    var current,
        next;

    if (this.empty()) {
        return false;
    }

    current = this.stack[0];
    next = current.collection[current.i];
    current.i++;

    if (current.i === current.collection.length) {
        this.stack.shift();
    }

    return next;
};

TraversingStack.prototype.empty = function empty() {
    return !this.stack.length;
};

module.exports = TraversingStack;
